import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=849f7902"
import script from "./Node.vue?vue&type=script&lang=ts"
export * from "./Node.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports